export const banner1 = 'https://images.contentstack.io/v3/assets/blt06f605a34f1194ff/blt3b95eb80fc90652f/5ed0cac3817e574fa1dccbb9/1-smaller.jpg';

export const banner2 = 'https://images.contentstack.io/v3/assets/blt06f605a34f1194ff/bltd13f4d888e780971/5ed0cb9db8eb8d0b28e6c996/2-smaller.jpg';

export const banner3 = 'https://images.contentstack.io/v3/assets/blt06f605a34f1194ff/blt6c88908c70e6d897/5ed0cba3b8eb8d0b28e6c99a/3-smaller.jpg';
